module.exports = __webpack_public_path__ + "img/search.8d63dc3b.svg";